import { Calendar } from 'vanilla-calendar-pro';

export default function initDatepicker() {
  // Find all inputs with datepicker
  const datepickerInputs = document.querySelectorAll('[data-input-datepicker]');

  if (!datepickerInputs) {
    return;
  }
  // Initialize calendar for each input
  datepickerInputs.forEach(function (input) {
    const calendar = new Calendar(input, {
      inputMode: true,
      onChangeToInput(self) {
        if (!self.context.inputElement) return;
        console.log(self.context);
        if (self.context.selectedDates[0]) {
          const date = self.context.selectedDates[0].replace(/-/g, '/');
          self.context.inputElement.value = date;
          self.hide();
        } else {
          self.context.inputElement.value = '';
        }
      },
    });

    calendar.init();
  });
}
